import { useCompanyValues } from '@/providers';
import { useGetUserInfoQuery } from '@/services/endpoints/users';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { TermsAndConditionsModal } from '../TermsAndConditions';
import { ExternalFooter, Footer } from './Footers';
import { LayoutRoutes } from './Layout.routes';
import { ExternalSidebar, Sidebar } from './Sidebars';
import { useGetConnectorTranslationsQuery } from '@/services/endpoints/workspace-connectors';

const Layout: FC = () => {
  useGetConnectorTranslationsQuery();

  const { isDefault } = useCompanyValues();

  const { data: userInfo } = useGetUserInfoQuery();

  return (
    <>
      <div className='flex h-screen flex-col overflow-hidden' data-testid='layout'>
        {isDefault ? <Sidebar /> : <ExternalSidebar />}
        <div
          className={twMerge(
            'flex h-main flex-col ps-sidebar-short peer-data-[pinned=true]:ps-sidebar-full grow',
            'motion-safe:transition-[padding] motion-safe:duration-500 motion-reduce:transition-none'
          )}
        >
          <main className='relative flex size-full flex-col overflow-y-auto bg-primary-background'>
            <LayoutRoutes />
          </main>
        </div>
        {isDefault ? <Footer /> : <ExternalFooter />}
      </div>
      {!userInfo?.termsAccepted && <TermsAndConditionsModal />}
    </>
  );
};

export default Layout;
